import { useEffect } from 'react'
import { Outlet, useParams, Navigate } from 'react-router-dom'
import { useAppStore } from '@shared/store'
import type { Lang } from '@shared/lib/i18n'

// 한국어 전용 — 영어 지원을 되살리려면 `eng: 'en'`을 다시 추가한다.
const LOCALE_MAP: Record<string, Lang> = {
  kor: 'ko',
}

export function LocaleLayout() {
  const { locale } = useParams<{ locale: string }>()
  const setLang = useAppStore((s) => s.setLang)

  const lang = locale ? LOCALE_MAP[locale] : undefined

  useEffect(() => {
    if (lang) setLang(lang)
  }, [lang, setLang])

  if (!lang) return <Navigate to="/kor" replace />

  return <Outlet />
}
